import { IConfigModule } from 'build/types/configs'

const config: IConfigModule = {
  version: '2.0.0',
  allowReferral: true,
  filterPrizes: true,
  buttonsStart: ['signIn', 'signUp', 'google', 'facebook'],
  positiveLogoUrls: [],
  useSecondBackground: ['/profile', '/trivias', '/end'],
  imageStart: 'backgroundImage',
  welcome: 'ImgBackground',
  legalAgeDate: true,
  routesLinks: [
    {
      path: '/trivias',
      text: 'VER TRIVIAS'
    },
    {
      path: '/profile',
      text: 'Mi información'
    },
    {
      path: '/help',
      text: '¿Tienes alguna duda?',
      small: true
    },
    {
      path: '/terms-and-conditions',
      text: 'Ver términos y condiciones',
      small: true
    },
    {
      path: '/privacy-politics',
      text: 'Ver política de privacidad',
      small: true
    }
  ],
  routesHome: ['RockID'],
  routesProfile: ['information', 'address', 'phone', 'history', 'identificacion'],
  notAvailableFields: [
    'instagram',
    'neighborhood',
    'postalCode',
    'city',
    'state',
    'country',
    'street1',
    'streetNumber',
    'curp',
    'address',
    'interests',
    'consumptionCenter',
    'sign'
  ],
  privacyPolitics: 'MX',
  cookies: 'MX',
  trivia: {
    showIntroduction: false,
    interestsRequired: true
  },
  notShowFields: ['instagram'],
  album: {
    Foto: {
      list: {
        handleClick: true,
        urlRedirectAlbumProgress: '/album/:id/upload',
        urlRedirectAlbumComplete: '/album/:id/ranking'
      },
      ranking: {
        showSocial: 'like',
        titleUpload: true
      },
      profile: {
        showSocial: ''
      },
      upload: {
        isTakeFoto: false,
        showHowToParticipate: true,
        warningPhoto: true,
        useLoaderValidate: true,
        validate: true
      }
    },
    Card: {
      list: {
        handleClick: true,
        urlRedirectAlbumProgress: '/album/:id/upload'
      },
      ranking: {
        titleUpload: true,
        viewMore: true,
        showSocial: 'like'
      },
      imageId: {
        showSocial: 'like'
      },
      upload: {
        showHowToParticipate: true,
        validate: true,
        useLoaderValidate: true,
        howTakePhoto: true,
        useCongrats: true,
        useCongratsDirect: true,
        inSubmitShowShareImage: true
      },
      congrats: {
        showButton3: true
      },
      profile: {
        showSocial: 'like|share',
        profileMultimediaOutputShare: 'base64'
      }
    }
  },
  comingSoon: false,
  captureBtnBgTransparent: true,
  marketplace: 'v2',
  wheel: {
    backgroundColors: ['#005943', '#008065'],
    textColors: ['#FFF'],
    outerBorderColor: 'transparent',
    outerBorderWidth: 0,
    innerBorderColor: '#eeeadf',
    innerBorderWidth: 60,
    innerRadius: 0,
    radiusLineColor: 'transparent',
    radiusLineWidth: 0,
    fontFamily: 'Nunito',
    fontWeight: 'bold',
    fontSize: 20,
    fontStyle: 'normal',
    textDistance: 60,
    perpendicularText: true,
    sizeMultiplier: 1.3,
    offsetY: 100
  },
  tracking: false
}

export default config
